import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import DetailWrapper from '../../../sharedcomponents/4layouts/DetailWrapper';
import useDetailEditMode from '../../../sharedcomponents/4layouts/useDetailEditMode';
import LeftCard from '../../../sharedcomponents/5templates/detailCards/leftCard';
import ListBucketCard from '../../../sharedcomponents/5templates/detailCards/listBucketCard';
import useLocation from './useLocation';
import LeftChildBuilding from './LeftChildBuilding';

const BuildingDetail = ({ createMode }) => {
  const [types, setTypes] = useState([]);
  let { assetId, type } = useParams();
  const formikFunctionBucket = {};

  const { detailEditMode, setDetailEditMode } = useDetailEditMode(createMode);

  const {
    entityDisplayNameFromParams,
    listAssetTypes,
    bulkUpdateLocationsCallBack,
    useGetOneAssetQuery,
    fetchAuxiliaryRecords,
    makeInMemoryLocationRecord,
    finalAuxiliaryRecords,
    upsertLocationCallback,
    fetchBuildingAddress,
    removeLocation,
    suspendAsset,
    loading: updateBuildingLoading
  } = useLocation();

  const {
    data: { data: rawAssetRecord } = {
      data: {}
    },
    refetch,
    isLoading,
    isSuccess
  } = useGetOneAssetQuery(
    {
      include: ['counts'],
      id: assetId
    },
    { skip: createMode, refetchOnMountOrArgChange: true }
  );

  const loading = useMemo(
    () => updateBuildingLoading || isLoading,
    [updateBuildingLoading, isLoading]
  );

  const primaryAssetRecord = createMode
    ? makeInMemoryLocationRecord(type)
    : JSON.parse(JSON.stringify(rawAssetRecord));
  primaryAssetRecord.refetch = refetch;

  useEffect(() => {
    const getData = async () => {
      const allTypes = await listAssetTypes();
      setTypes(allTypes.filter((type) => type.config.is_container === true));

      if (createMode) {
        // Update the form with the correct type now we've
        // loaded in all the types
        const initialType = allTypes.find((t) => t.base_type === type);
        formikFunctionBucket.setFieldValue('type_id', initialType.id, false);
        formikFunctionBucket.setFieldValue('config', initialType.config, false);
      }
    };
    getData();

    // This one legit cannot contain the listAssetTypes
    // eslint-disable-next-line
  }, []);

  const typeIdToDisplayName = (typeId) => {
    typeId = typeId ?? primaryAssetRecord.type_id;
    return types?.find((t) => t.id === typeId)?.name ?? '';
  };

  const observeValueChange = async (values) => {
    if (values.hasOwnProperty('parent_id')) {
      const newParentId = values.parent_id;
      const oldParentId = primaryAssetRecord.parent_id;

      if (oldParentId !== newParentId) {
        const buildingAddress = await fetchBuildingAddress(newParentId);

        if (formikFunctionBucket.setFieldValue) {
          formikFunctionBucket.setFieldValue(
            'address.country',
            buildingAddress.country,
            false
          );
          formikFunctionBucket.setFieldValue(
            'address.region',
            buildingAddress.region,
            false
          );
          formikFunctionBucket.setFieldValue(
            'address.city',
            buildingAddress.city,
            false
          );
          formikFunctionBucket.setFieldValue(
            'address.postal',
            buildingAddress.postal,
            false
          );
          formikFunctionBucket.setFieldValue(
            'address.locale',
            buildingAddress.locale,
            false
          );

          formikFunctionBucket.setFieldValue(
            'address.unit',
            buildingAddress.unit,
            false
          );
          formikFunctionBucket.setFieldValue(
            'address.street',
            buildingAddress.street,
            false
          );

          formikFunctionBucket.setFieldValue(
            'address.lat',
            buildingAddress.lat,
            false
          );

          formikFunctionBucket.setFieldValue(
            'address.long',
            buildingAddress.long,
            false
          );
        }
      }
    }
  };

  const setGeoCallback = useCallback(
    (geo) => {
      formikFunctionBucket.setFieldValue('geo.long', geo.long, false);
      formikFunctionBucket.setFieldValue('geo.lat', geo.lat, false);
    },
    [formikFunctionBucket]
  );

  return (
    <DetailWrapper
      entityDisplayName={entityDisplayNameFromParams(type)}
      detailEditMode={detailEditMode}
      setDetailEditMode={setDetailEditMode}
      typeIdToDisplayName={typeIdToDisplayName}
      primaryDetailRecord={primaryAssetRecord}
      isLoading={!createMode && (loading || !isSuccess)}
      secondaryDataLoaderCallBack={fetchAuxiliaryRecords}
      upsertDetailCallback={upsertLocationCallback}
      bulkUpdateCallBack={bulkUpdateLocationsCallBack}
      finalAuxiliaryRecords={finalAuxiliaryRecords}
      optionalListenerToFormikValidation={observeValueChange}
    >
      {({ formikProps, activationChangeCallback, deleteEntityCallback }) => {
        formikFunctionBucket.setFieldValue = formikProps.setFieldValue;
        return (
          <>
            <div style={{ float: 'left', width: '34%' }}>
              <LeftCard
                entityDisplayName={entityDisplayNameFromParams(type)}
                formikProps={formikProps}
                editMode={detailEditMode}
                typeIdToDisplayName={typeIdToDisplayName}
                deleteEntityCallback={deleteEntityCallback(removeLocation)}
                activationChangeCallback={activationChangeCallback(
                  suspendAsset
                )}
                listOfTypes={types}
                arrayOfBucketConfig={finalAuxiliaryRecords?.primero}
              >
                <LeftChildBuilding
                  formikProps={formikProps}
                  editMode={detailEditMode}
                  createMode={createMode}
                  assetTypes={types}
                  entities={finalAuxiliaryRecords?.entities}
                  setGeo={setGeoCallback}
                />
              </LeftCard>
            </div>
            <div style={{ float: 'left', width: '65%' }}>
              <ListBucketCard
                formikProps={formikProps}
                editMode={detailEditMode}
                arrayOfBucketConfig={finalAuxiliaryRecords?.segundo}
              />
            </div>
          </>
        );
      }}
    </DetailWrapper>
  );
};
export default BuildingDetail;
